module.exports = __webpack_public_path__ + "img/2300101dcl2.5c23b071.png";